<section [formGroup]="group" class="section" *ngIf="group">
  <header class="section-header">
    <h4>{{ title }}</h4>
    <span class="hint">{{ requirementLabel }}</span>
  </header>

  <div class="mode-toggle">
    <app-trigger-mode-radio-group
      formControlName="mode"
      [options]="modeOptions"
    ></app-trigger-mode-radio-group>
  </div>

  <p class="hint" *ngIf="mode === 'generate'">
    {{ generateHint }}
  </p>

  <div class="fields" *ngIf="mode === 'specify'">
    <div class="field checkbox">
      <label>
        <input type="checkbox" formControlName="allows_push" />
        <span>Push permission granted</span>
      </label>
    </div>

    <div class="field">
      <label>Location Permission</label>
      <mat-form-field appearance="outline">
        <mat-select formControlName="location_permission">
          <mat-option *ngFor="let opt of locationPermissionOptions" [value]="opt.value">
            {{ opt.label }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div class="field">
      <label>App Version</label>
      <mat-form-field appearance="outline">
        <input matInput formControlName="app_version" placeholder="1.0.0" />
      </mat-form-field>
    </div>

    <div class="field">
      <label>Locale</label>
      <mat-form-field appearance="outline">
        <input matInput formControlName="locale" placeholder="en-US" />
      </mat-form-field>
    </div>
  </div>

  <p class="hint" *ngIf="mode === 'specify'">
    {{ specifyHint }}
  </p>
</section>
